import * as React from "react";

export const fields = (maxLength, t) => {
    return {
        config: {columns: 1},
        fields: [

            {
                name: "note",
                label: t ? t("common.note") : "Note",
                type: "textarea",
                maxLength: maxLength,
                column: 1,
            },
        ]
    }
};
